/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import PersonType from '@linc-technologies/linced-common/enums/person-type';

export default class ResequenceGroupsController extends Controller {
  @action
  setSelectedTab(value) {
    this.selectedTab = value;
  }

  personTypes = PersonType.values;
  @tracked selectedTab = PersonType.LEARNER;

  @computed('model.[]', 'selectedTab')
  get typeGroups() {
    let selectedTab = this.selectedTab;
    return this.model
      .filter((group) => group.personType === selectedTab)
      .sort(
        (a, b) =>
          a.sequence - b.sequence || (a.name || '').localeCompare(b.name || ''),
      );
  }

  // drag-drop sorting
  @action
  sortDragEnd({ sourceList, sourceIndex, targetList, targetIndex }) {
    if (sourceList === targetList && sourceIndex === targetIndex) {
      return;
    }

    const item = sourceList[sourceIndex];

    sourceList.splice(sourceIndex, 1);
    targetList.splice(targetIndex, 0, item);

    targetList.forEach((entity, index) => {
      entity.set('sequence', index + 1);
      entity.save();
    });
  }
}
